import i18next from "i18next";
import {
    IAuditActionType,
    IAuditEntityType,
    IAuditLevel,
    IAuditSourceSystem,
    IAuthenticationType,
    ILogicTypeEnum,
    ILogType,
    IOperationType,
    IParamType,
    IParamValueType,
    IRequestPayloadType,
    IServiceConsumingType,
    IServiceSecurityImplicitType,
    ITransactionMethod
} from "../interfaces/IUtilities";

export const ServiceSecurityImplicitTypeText = {
  [IServiceSecurityImplicitType.Unknown]: "UnKnown",
  [IServiceSecurityImplicitType.Public]: "Public",
  [IServiceSecurityImplicitType.RequiresACL]: "Requires ACL"
};

export const ServiceConsumingTypeText = {
  [IServiceConsumingType.Unknown]: 'UnKnown',
  [IServiceConsumingType.RequestLib]: 'Request Library',
  [IServiceConsumingType.TransformLib]: 'Transform library', //It is not used
  [IServiceConsumingType.Passthrough]: 'Passthrough'
};

export const AuthenticationTypeText = {
  [IAuthenticationType.Unknown]: 'Unknown',
  [IAuthenticationType.None]: 'None',
  [IAuthenticationType.HandledByLib]: 'Handled by library',
  [IAuthenticationType.Jwt]: 'JWT',
  [IAuthenticationType.HeaderApiKey]: 'Header Api Key'
};

export const RequestPayloadTypeText = {
  [IRequestPayloadType.Unknown]: 'Unknown',
  [IRequestPayloadType.JSON]: 'JSON',
  [IRequestPayloadType.XML]: 'XML'
};

export const ParamTypeText = {
  [IParamType.Unknown]: '',
  [IParamType.AuthParam]: 'Authorization Parameter',
  [IParamType.HeaderParam]: 'Header Parameter'
};

export const ParamValueTypeText = {
  [IParamValueType.Unknown]: '',
  [IParamValueType.Bool]: 'Boolean',
  [IParamValueType.Int]: 'Integer',
  [IParamValueType.Long]: 'Long',
  [IParamValueType.Decimal]: 'Decimal',
  [IParamValueType.String]: 'String'
};

export const TransactionMethodText = {
  [ITransactionMethod.Unknown]: 'Unknown',
  [ITransactionMethod.GET]: 'GET',
  [ITransactionMethod.POST]: 'POST',
  [ITransactionMethod.PUT]: 'PUT',
  [ITransactionMethod.DELETE]: 'DELETE'
};

export const OperationTypeText = {
  [IOperationType.Unknown]: 'Unknown',
  [IOperationType.Sync]: 'Sync',
  [IOperationType.Async]: 'Async'
};

export const LogicTypeEnumText = {
    [ILogicTypeEnum.AND]: 'AND',
    [ILogicTypeEnum.OR]: 'OR',
    [ILogicTypeEnum.LEAF]: 'LEAF',
    [ILogicTypeEnum.ANDNOT]: 'AND NOT',
    [ILogicTypeEnum.ORNOT]: 'OR NOT'
};

export const AuditActionTypeEnumText = {
    [IAuditActionType.Unknown]: '',
    [IAuditActionType.Action]: 'Action',
    [IAuditActionType.Create]: 'Create',
    [IAuditActionType.Update]: 'Update',
    [IAuditActionType.Delete]: 'Delete',
    [IAuditActionType.Login]: 'Login',
    [IAuditActionType.Verify]: 'Verify',
    get [IAuditActionType.OtpEmailSent]() { return i18next.t('AuditActionOtpEmailSent'); },
    get [IAuditActionType.OtpSmsSent]() { return i18next.t('AuditActionOtpSmsSent'); },
    get [IAuditActionType.OtpEmailCcSent]() { return i18next.t('AuditActionOtpEmailCcSent'); }
};
export const AuditEntityTypeEnumText = {
    [IAuditEntityType.Unknown]: '',
    [IAuditEntityType.User]: 'User',
    [IAuditEntityType.Role]: 'Role',
};

export const AuditSourceSystemEnumText = {
    [IAuditSourceSystem.Unknown]: '',
    [IAuditSourceSystem.Keycloak]: 'Keycloak',
    [IAuditSourceSystem.Transformations]: 'Transformations',
    get [IAuditSourceSystem.Notifications]() { return i18next.t('AuditSourceNotifications'); },
};

export const LogTypeEnumText = {
    [ILogType.DIS_REQUEST]: 'DIS_REQUEST',
    [ILogType.DIS_RESPONSE]: 'DIS_RESPONSE',
    [ILogType.SERVICE_REQUEST]: 'SERVICE_REQUEST',
    [ILogType.SERVICE_RESPONSE]: 'SERVICE_RESPONSE',
    [ILogType.DIS_EXCEPTION]: 'DIS_EXCEPTION',
};

export const AuditLevelEnumText = {
    [IAuditLevel.AuditLevel1]: 'AuditLevel1',
    [IAuditLevel.AuditLevel2]: 'AuditLevel2',
};


